import { BroadcastFilters, LifecycleSegment } from "../services/broadcast";

const SEGMENT_LABELS: Record<LifecycleSegment, string> = {
  LEAD: "Lead",
  NEW: "New",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  AT_RISK: "At-risk",
  CHURNED: "Churned",
};

/**
 * Human-readable summary of a broadcast's audience, for the history/scheduled
 * tables. Accounts for lifecycle segments, hand-picked users and the test-user
 * mode — so a broadcast sent to a specific set is never mislabelled "All users".
 */
export function summariseAudience(filters: BroadcastFilters): string {
  const parts: string[] = [];
  const push = (arr?: string[]) => {
    if (arr?.length) parts.push(...arr);
  };

  if (filters.lifecycle?.length) {
    parts.push(...filters.lifecycle.map((s) => SEGMENT_LABELS[s] ?? s));
  }
  push(filters.tiers);
  push(filters.risk_category);
  push(filters.behavior_tags);
  push(filters.hrc_status);
  push(filters.mc_status);
  push(filters.user_type);
  if (filters.region) parts.push(filters.region);
  if (filters.user_ids?.length) {
    parts.push(
      `${filters.user_ids.length} hand-picked user${
        filters.user_ids.length === 1 ? "" : "s"
      }`,
    );
  }
  if (filters.test_users === "ONLY") parts.push("test users only");

  if (parts.length === 0) {
    return filters.test_users === "INCLUDE" ? "All users (incl. test)" : "All users";
  }
  return parts.join(", ") + (filters.test_users === "INCLUDE" ? " · incl. test" : "");
}
